module.exports = __webpack_public_path__ + "static/media/ic_advertising_blue.f17437f5.svg";